import { Head } from '@inertiajs/react'
import AppLayout from '@/components/AppLayout'
import { LeaderboardPage } from '@/components/screens/LeaderboardScreen'

/* The Inertia boundary. The screen below still reads from @/fixtures; when a
 * controller starts handing this page real props they get passed through here,
 * and the screen stops importing fixtures at all. */
export default function Leaderboard() {
  return (
    <AppLayout>
      <Head title="Leaderboard" />
      <LeaderboardPage />
    </AppLayout>
  )
}
